<template>
    <label :for="id" :class="['flex items-center space-x-2 px-2 py-1 cursor-pointer']">
        <input type="checkbox" :id="id" :checked="modelValue" @change="$emit('update:modelValue', $event.target.checked)" class="form-checkbox cursor-pointer" />
        <span>{{ label }}</span>
        <span v-if="tooltip" v-tippy="tooltip" class="relative group">
            <font-awesome-icon icon="question-circle" class="h-4 w-4" />
        </span>
    </label>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false
        },
        modelValue: {
            type: [Boolean, Number],
            required: false
        },
        label: {
            type: String,
            required: false
        },
        tooltip: {
            type: String,
            required: false,
        }
    },
    mounted() {
        //
    }
}
</script>
